import { Avatar, styled } from '@mui/material';

import { IAvatarStyledProps } from './types';
import { getAvatarBorderColor } from './constant';

export const AvatarStyled = styled(Avatar)<IAvatarStyledProps>`
  cursor: ${({ ownerState }) => (ownerState.imageSelected || ownerState.imageUrl ? 'pointer' : 'default')};
  border-color: ${({ theme, ownerState }) => getAvatarBorderColor(theme, ownerState)};
  border-width: 2px;
  border-style: solid;
`;
